<template>
  <div id="newHome">
    <home-nav></home-nav>
    <div class="height70"></div>
    <new-home-banner></new-home-banner>
    <new-hot></new-hot>
    <new-main></new-main>
    <back-top></back-top>
    <public-footer></public-footer>
  </div>
</template>

<script>
import {
  gethomepc
} from "@/config/api.js";
//  import vns from 'vue-number-scroll';
// import HomeNav from "./components/NewHomeNav.vue";
import HomeNav from "@/components/PublicHeader.vue";
import NewHomeBanner from "./components/Banner.vue";
import NewHot from "./components/NewHot.vue";
import NewMain from "./components/NewMain.vue";
import BackTop from "@/components/BackTop.vue";
import PublicFooter from "@/components/PublicFooter.vue";
// import axios from "axios";
export default {
  name: "NewHome",
  data() {
    return {
      dialogService:false,
      banner: [],
      keys: "",
    };
  },
  components: {
    PublicFooter,
    HomeNav,
    NewHomeBanner,
    NewHot,
    NewMain,
    BackTop
  },
  methods: {
    getInfo() {
      this.$post(gethomepc,{
        key:'pc_home_page'
      })
        .then(res => {
          let data = JSON.parse(res.data);
          let {lr_data} = data;
          for(let i =0;i<this.exteion.length;i++)
          {
            this.exteion[i].title = lr_data.data[i].title;
            this.exteion[i].contents = lr_data.data[i].content;
            this.exteion[i].image = lr_data.data[i].image;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
  }
};
</script>

<style>

</style>
